<template>
  <div>
    <div class="ml-3">
      <div class="column">
        <div id="toolbar" class="row mb-3"></div>

        <form
          id="formBsTable"
          class="col-12 collapse"
          @submit.prevent="onSubmit"
        >
          <div class="row">
            <slot></slot>
          </div>

          <div class="form-group">
            <button
              id="search"
              class="btn btn-primary btn-sm mr-2"
              type="submit"
              :disabled="disableSearch"
            >
              {{ $t('search') }}
            </button>

            <button
              id="clear"
              class="btn btn-white btn-sm"
              type="button"
              v-on:click="clear"
            >
              {{ $t('clear') }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <BootstrapTable
      id="table"
      ref="table"
      class="bg-white"
      style="font-size: 10px;"
      :columns="columns"
      :data="data"
      @onSort="onSort"
      @onRefresh="onRefresh"
      @onPageChange="onPageChange"
      :options="options"
      :defaultOptions='defaultOptions'
    />
  </div>
</template>
<script>
import { request } from '@/lib/http'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import optionsBsTable from '@/config/optionsBsTable'
import { mapState } from 'vuex'
export default {
  components: {
    BootstrapTable
  },
  props: {
    url: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    defaultSort: {
      type: String,
      required: true
    },
    defaultOrder: {
      type: String,
      required: true
    },
    query: {
      type: Object,
      required: true
    },
    defaultOptions: {
      type: Object,
      default: () => {}
    },
    clear: {
      type: Function
    },
    loadOnMount: {
      type: Boolean,
      default: process.env.NODE_ENV === 'development' ? false : true
    },
    startSearchOpen: {
      type: Boolean,
      default: false
    },
    disableSearch: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      offset: 0,
      limit: optionsBsTable.pageSize,
      sort: 'model',
      order: 'asc',
      data: [],
      options: optionsBsTable
    }
  },

  watch: {
    bstableData(value) {
      this.data = value
    }
  },

  computed: {
    ...mapState({
      bstableData: state => state.bstable.all
    })
  },

  methods: {
    getQuery () {
      const result = {}
      for (let field in this.query) {
        if (this.query[field] !== '') {
          result[field] = this.query[field]
        }
      }
      return result
    },

    async searchFiltered () {
      // $('#table').bootstrapTable('showLoading')
      // this.$refs.table.showLoading()

      const { dispatch } = this.$store

      try {
        dispatch('overlay/show', true)

        const params = {
          offset: this.offset || 0,
          limit: this.limit === this.$t('all') ? this.data.total : this.limit,
          sort: this.sort,
          order: this.order,
          ...this.getQuery()
        }

        this.data = await request({
          url: this.url,
          method: 'get',
          params
        })

        this.$store.dispatch('bstable/fetchAll', this.data)
      } catch (e) {
      } finally {
        // $('#table').bootstrapTable('hideLoading')
        dispatch('overlay/show', false)
      }
    },

    async onSubmit () {
      this.offset = 0
      this.searchFiltered()
      $('#formBsTable').collapse('hide')
    },

    async onSort (sort, order) {
      this.sort = sort
      this.order = order
      this.onSubmit()
    },

    async onRefresh () {
      this.searchFiltered()
    },

    async onPageChange (page, limit) {
      this.offset = page * limit - limit
      this.limit = limit
      this.searchFiltered()
    }
  },

  beforeMount () {
    this.sort = this.defaultSort
    this.order = this.defaultOrder
    this.options = {
      ...this.options,
      ...this.defaultOptions
    }
    this.options.sortName = this.sort
    this.options.sortOrder = this.order
  },

  async mounted () {
    $('#toolbar')
      .find('div:first')
      .append(
        `<a id="toggleSearch" class="btn btn-secondary text-white buttons-toolbar" data-toggle="collapse" data-target="#formBsTable" aria-expanded="${this.startSearchOpen.toString()}" aria-controls="formBsTable"><i class="fa fa-search"></i></a>`
      )

    $('#formBsTable').on('show.bs.collapse', function () {
      $('#toggleSearch').addClass('active')
    })

    $('#formBsTable').on('hide.bs.collapse', function () {
      $('#toggleSearch').removeClass('active')
    })

    if (this.startSearchOpen) {
      $('#formBsTable').collapse('show')
    }

    if (this.loadOnMount) {
      this.searchFiltered()
    }
  }
}
</script>
